import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import useSeo from "@/lib/useSeo";
import { toast } from "sonner";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  useSeo({ title: "Reset password — ONUSA" });
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };
  return (
    <div className="onusa-container py-20 max-w-md" data-testid="forgot-page">
      <h1 className="heading-x text-2xl mb-6">WACHTWOORD RESETTEN</h1>
      {sent ? <p className="text-sm text-[#77736D]">Als dat e-mailadres bestaat, is er een resetlink verstuurd. Controleer je inbox.</p> : (
        <form onSubmit={submit} className="space-y-4">
          <input required type="email" placeholder="E-mail" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-white border border-[#E8E1D8] px-3 py-2.5 text-sm outline-none focus:border-[#1D1D1B]" data-testid="forgot-email" />
          <button className="btn-x w-full" data-testid="forgot-submit">STUUR RESETLINK</button>
        </form>
      )}
      <Link to="/account" className="label-x mt-5 inline-block">← TERUG</Link>
    </div>
  );
}

export function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  useSeo({ title: "Set new password — ONUSA" });
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/auth/reset-password", { token: params.get("token"), password }); toast.success("Wachtwoord bijgewerkt"); navigate("/account"); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };
  return (
    <div className="onusa-container py-20 max-w-md" data-testid="reset-page">
      <h1 className="heading-x text-2xl mb-6">NIEUW WACHTWOORD INSTELLEN</h1>
      <form onSubmit={submit} className="space-y-4">
        <input required type="password" placeholder="Nieuw wachtwoord" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-white border border-[#E8E1D8] px-3 py-2.5 text-sm outline-none focus:border-[#1D1D1B]" data-testid="reset-password" />
        <button className="btn-x w-full" data-testid="reset-submit">WACHTWOORD BIJWERKEN</button>
      </form>
    </div>
  );
}
